import { Dictionary, DirectusFiles, LearningEvent } from 'src/types'
import { Level, Unit } from '../model/types/game-map'
import { AbstractControl, ValidatorFn } from '@angular/forms'

export interface StudentInfo {
  id: string
  name: string
  email: string
  isSelected: boolean
  isPending: boolean
  isDictionaryPending: boolean
  dictionary?: Dictionary
  hasLoggedIn?: boolean
  hasPlayed?: boolean
  avatar: string | DirectusFiles | null
  gameMap?: Unit[]
  unitCompleted?: number
  bonusLevelCompleted?: number
  levelAssigned?: LearningEvent[]
  bonusLevelAssigned?: LearningEvent[]
}

export interface StudentForm {
  isSelected: boolean
  student: StudentInfo
}

export interface UnitAssignInfo {
  unitIndex: number
  unitData: Unit[]
  unitSelectAll: boolean
  bonusActivities: boolean
  levels: LevelAssignInfo[]
}

export interface LevelAssignInfo {
  levelIndex: number
  levelData: Level[]
  isSelected: boolean
}

export interface AssignIndex {
  levelIndex: number
  unitIndex: number
  includeActivities: boolean
}

export const IMPORT_USERS_SAMPLE_FILE = 'Import Users Sample'

export enum FileOption {
  Upload = 'Upload',
  DownLoad = 'Download'
}

export enum ImportStage {
  PreImport = 'PreImport',
  Import = 'Import',
  PostImportSuccess = 'PostImportSuccess',
  PostImportFail = 'PostImportFail'
}

export enum AddUserStage {
  Email = 'Email',
  Main = 'Main'
}

export const classNameValidator =
  (existingClassNames: string[]): ValidatorFn =>
  (control: AbstractControl) => {
    return existingClassNames.includes(control.value) ? { duplicated: true } : null
  }

export enum GroupMemberCollection {
  Member = 'group_directus_users',
  PendingMember = 'group_directus_users_1'
}

export const UserOrganisationsCollection = 'junction_directus_users_organisation'

export const BurragaSVGIcon = `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      viewBox="0 0 123.3 120.2" style="enable-background:new 0 0 123.3 120.2;" xml:space="preserve">
      <style type="text/css">
        .st0{fill:#FFFFFF;}
        .st1{fill:#B34426;}
        .st2{fill:#F0592C;}
      </style>
      <path id="Fill-1" class="st0" d="M11.7,53.5c0.1-0.1,0.2-0.3,0.4-0.4c4.5-5.3,0.5-10.7-4.9-10.9c-1.9-0.1-3.7,0.7-4.9,2
        c-2.2,2.2-2.9,5.7-1.4,8C3,55.6,8.2,57,11.7,53.5"/>
      <path id="Fill-4" class="st1" d="M19.7,91.7l0.5-0.5c5.6-6.6,0.6-13.4-6.2-13.7c-2.3-0.1-4.6,0.8-6.2,2.5c-2.7,2.8-3.6,7.1-1.7,10
        C8.9,94.2,15.4,96.1,19.7,91.7"/>
      <path id="Fill-6" class="st2" d="M31.8,10.3l0.2-0.2c2.1-2.5,0.2-5.1-2.4-5.2c-0.9,0-1.8,0.3-2.4,1c-1.1,1-1.3,2.5-0.7,3.8
        c1,1.6,3.1,2.1,4.6,1.1C31.5,10.6,31.7,10.5,31.8,10.3"/>
      <path id="Fill-8" class="st1" d="M19.7,37.5c0.2-0.2,0.3-0.3,0.5-0.5c5.5-6.5,0.6-13.2-6.1-13.5c-2.3-0.1-4.5,0.8-6.1,2.5
        c-2.7,2.7-3.6,7.1-1.7,9.9C8.9,40.1,15.4,41.9,19.7,37.5"/>
      <path id="Fill-10" class="st2" d="M14.6,72.1l0.5-0.5c5.5-6.6,0.6-13.3-6.1-13.5c-2.3-0.1-4.5,0.8-6.1,2.5c-2.7,2.7-3.6,7-1.7,9.9
        C3.9,74.7,10.4,76.5,14.6,72.1"/>
      <path id="Fill-12" class="st2" d="M62.8,117.5c0.2-0.2,0.3-0.4,0.5-0.6c5.9-6.9,0.7-14-6.5-14.3c-2.4-0.1-4.8,0.9-6.5,2.7
        c-2.8,2.9-3.8,7.5-1.8,10.5C51.5,120.2,58.3,122.1,62.8,117.5"/>
      <path id="Fill-14" class="st1" d="M114.3,90c0.2-0.2,0.4-0.4,0.6-0.6c6.6-7.8,0.8-15.7-7.3-16c-2.7-0.1-5.4,1-7.3,3
        c-3.2,3.2-4.3,8.4-2,11.7C101.6,93.1,109.3,95.3,114.3,90"/>
      <path id="Fill-16" class="st2" d="M114.9,41.1c0.1-0.1,0.3-0.3,0.4-0.5c4.8-5.7,0.6-11.5-5.3-11.7c-2-0.1-3.9,0.7-5.3,2.2
        c-2.3,2.4-3.1,6.1-1.5,8.6C105.6,43.3,111.2,44.9,114.9,41.1"/>
      <path id="Fill-18" class="st0" d="M84,25.9l0.5-0.5c5.7-6.7,0.7-13.6-6.3-13.9c-2.3-0.1-4.6,0.9-6.2,2.6c-2.7,2.8-3.7,7.2-1.8,10.1
        C73,28.5,79.6,30.4,84,25.9"/>
      <path id="Fill-20" class="st1" d="M48.2,53.2c0.1-0.1,0.3-0.3,0.4-0.4c4.8-5.6,0.5-11.4-5.3-11.6c-2-0.1-3.9,0.7-5.3,2.2
        c-2.3,2.3-3.1,6.1-1.5,8.5C39,55.4,44.6,56.9,48.2,53.2"/>
      <path id="Fill-22" class="st0" d="M86.1,70.1c0.1-0.1,0.2-0.3,0.4-0.4c4.3-5.1,0.5-10.3-4.8-10.5c-1.8,0-3.5,0.7-4.8,2
        c-2.1,2.1-2.8,5.5-1.3,7.7C77.7,72.2,82.7,73.6,86.1,70.1"/>
      <path id="Fill-24" class="st1" d="M77.2,47.2c0.1-0.1,0.2-0.2,0.2-0.3c2.8-3.3,0.3-6.7-3.1-6.8c-1.2,0-2.3,0.4-3.1,1.3
        c-1.3,1.4-1.8,3.6-0.9,5c1.3,2.1,4,2.7,6.1,1.4C76.7,47.6,77,47.4,77.2,47.2"/>
      <path id="Fill-26" class="st2" d="M77,79.8c0.1-0.1,0.2-0.2,0.3-0.3c3.2-3.7,0.4-7.6-3.5-7.7c-1.3,0-2.6,0.5-3.5,1.4
        c-1.5,1.6-2.1,4-1,5.7c1.5,2.3,4.6,3,6.9,1.6C76.5,80.3,76.7,80.1,77,79.8"/>
      <path id="Fill-28" class="st2" d="M48.5,75.5c0.1-0.1,0.2-0.2,0.3-0.3c3.5-4.1,0.4-8.3-3.8-8.5c-1.5-0.1-2.9,0.5-3.9,1.6
        c-1.7,1.8-2.3,4.5-1.1,6.2C41.7,77.1,45.8,78.3,48.5,75.5"/>
      <path id="Fill-30" class="st1" d="M64,29.2c0.1-0.1,0.3-0.3,0.4-0.4c4.2-4.9,0.5-10-4.6-10.2c-1.7-0.1-3.4,0.6-4.6,1.9
        c-2,2-2.7,5.3-1.3,7.5C55.9,31.1,60.8,32.5,64,29.2"/>
      <path id="Fill-32" class="st1" d="M101.1,29.9c0.1-0.1,0.3-0.3,0.4-0.4c4.6-5.5,0.5-11.1-5.1-11.3c-1.9-0.1-3.8,0.7-5.1,2.1
        c-2.2,2.3-3,5.9-1.4,8.3C92.1,32,97.5,33.5,101.1,29.9"/>
      <path id="Fill-34" class="st1" d="M120.7,69.4c0.1-0.1,0.3-0.3,0.4-0.4c5-5.5,0.6-11.1-5.4-11.2c-2-0.1-4,0.7-5.5,2.1
        c-2.4,2.3-3.3,5.9-1.6,8.3C111.1,71.6,116.8,73.1,120.7,69.4"/>
      <path id="Fill-36" class="st1" d="M81.4,114c0.1-0.1,0.3-0.3,0.4-0.4c4.5-5.4,0.5-10.9-5-11.1c-1.9-0.1-3.7,0.7-5,2.1
        c-2.2,2.2-3,5.8-1.4,8.1C72.6,116.1,77.9,117.6,81.4,114"/>
      <path id="Fill-38" class="st2" d="M42,112.5c0.1-0.1,0.3-0.3,0.4-0.4c4.5-5.4,0.5-10.9-5-11.1c-1.9-0.1-3.7,0.7-5,2.1
        c-2.2,2.2-2.9,5.8-1.4,8.1C33.2,114.6,38.5,116.1,42,112.5"/>
      <path id="Fill-40" class="st2" d="M65.4,60.7l0.1-0.1c1.4-1.7,0.2-3.4-1.6-3.5c-0.6,0-1.2,0.2-1.6,0.7c-0.7,0.7-0.9,1.7-0.4,2.6
        c0.7,1.1,2,1.4,3.1,0.7C65.1,60.9,65.3,60.8,65.4,60.7"/>
      <path id="Fill-42" class="st1" d="M66.9,47.5c0.1-0.1,0.2-0.2,0.2-0.2c2.6-3.1,0.3-6.2-2.9-6.3c-1.1,0-2.1,0.4-2.9,1.2
        c-1.3,1.2-1.6,3.1-0.8,4.7c1.2,1.9,3.7,2.5,5.7,1.3C66.4,47.9,66.7,47.7,66.9,47.5"/>
      <path id="Fill-44" class="st2" d="M119.5,53.3c0.1-0.1,0.2-0.2,0.3-0.3c3.2-3.8,0.4-7.7-3.6-7.9c-1.3,0-2.7,0.5-3.6,1.5
        c-1.6,1.6-2.1,4.1-1,5.8c1.5,2.4,4.6,3.1,7,1.6C118.9,53.8,119.2,53.6,119.5,53.3"/>
      <path id="Fill-46" class="st2" d="M43.1,64l0.2-0.2c2.6-3.1,0.3-6.2-2.9-6.3c-1.1,0-2.1,0.4-2.9,1.2c-1.3,1.2-1.6,3.1-0.8,4.6
        c1.2,1.9,3.7,2.5,5.6,1.3C42.7,64.4,42.9,64.2,43.1,64"/>
      <path id="Fill-48" class="st0" d="M39.1,4l0.1-0.2C40.8,2,39.4,0.1,37.5,0c-0.7,0-1.3,0.2-1.7,0.7c-0.8,0.7-1,1.9-0.5,2.8
        C36,4.7,37.5,5,38.7,4.3C38.8,4.2,39,4.1,39.1,4"/>
      <path id="Fill-51" class="st1" d="M86.5,55.8c0.1-0.1,0.2-0.2,0.3-0.3c3.5-4.2,0.4-8.5-3.9-8.6c-1.5-0.1-2.9,0.5-3.9,1.6
        c-1.7,1.7-2.3,4.5-1.1,6.3C79.6,57.5,83.7,58.6,86.5,55.8"/>
      <path id="Fill-53" class="st2" d="M25.3,21c0.1-0.1,0.2-0.2,0.3-0.3c3.3-3.9,0.4-7.9-3.6-8c-1.4,0-2.7,0.5-3.6,1.5
        c-1.6,1.6-2.1,4.2-1,5.9c1.5,2.4,4.7,3.2,7.1,1.7C24.7,21.6,25,21.3,25.3,21"/>
      <path id="Fill-55" class="st1" d="M52.1,38l0.3-0.3c3.1-3.7,0.4-7.5-3.5-7.6c-1.3,0-2.6,0.5-3.5,1.4c-1.5,1.5-2,4-1,5.6
        c1.4,2.3,4.5,3,6.8,1.6C51.6,38.5,51.8,38.3,52.1,38"/>
      <path id="Fill-57" class="st0" d="M27.4,103.6c0.1-0.1,0.2-0.2,0.3-0.3c3.4-4.1,0.4-8.2-3.8-8.4c-1.4,0-2.8,0.5-3.8,1.6
        c-1.6,1.7-2.2,4.4-1.1,6.2c1.6,2.5,4.9,3.3,7.5,1.7C26.8,104.1,27.1,103.9,27.4,103.6"/>
      <path id="Fill-59" class="st2" d="M98.9,106.7c0.2-0.2,0.3-0.4,0.5-0.5c5.6-6.8,0.6-13.7-6.2-13.9c-2.3-0.1-4.6,0.9-6.2,2.6
        c-2.7,2.8-3.6,7.3-1.7,10.2C88,109.3,94.5,111.2,98.9,106.7"/>
      <path id="Fill-61" class="st2" d="M62.7,55.2c0.1-0.1,0.1-0.1,0.2-0.2c2.3-2.7,0.3-5.5-2.5-5.6c-1,0-1.9,0.3-2.5,1
        c-1.1,1.1-1.4,2.7-0.7,4.1c1.1,1.7,3.3,2.2,5,1.2C62.3,55.5,62.5,55.4,62.7,55.2"/>
      <path id="Fill-63" class="st1" d="M64,82.9c0.1-0.1,0.3-0.3,0.4-0.4c4.8-5.7,0.6-11.5-5.3-11.8c-2-0.1-3.9,0.7-5.3,2.2
        c-2.3,2.4-3.1,6.1-1.5,8.6C54.7,85.1,60.3,86.7,64,82.9"/>
      </svg>`
